export default __webpack_public_path__ + "static/media/TickBox.bbf46272.svg";